export const WIFI_NETWORK_KIND = 38787;
export const WIFI_CORRECTION_KIND = 8787;

export const WIFI_SECURITY_TYPES = {
  WPA: "WPA",
  WPA2: "WPA2",
  WPA3: "WPA3",
  WEP: "WEP",
  nopass: "None",
};

export const DEFAULT_RELAYS = ["wss://relay.damus.io", "wss://nos.lol"];
export const DEFAULT_LOOKUP_RELAYS = [
  "wss://purplepag.es/",
  "wss://user.kindpag.es/",
];
